// import attachEnterAsClick from 'utils/attachEnterAsClick';
import $ from 'jquery';

const generateItem = data => {
    const item = $('.js-search-result-item-template').clone();
    item.removeClass('hide js-search-result-item-template');
    item.attr('href', data.link);
    item.find('.title').text(data.title);
    item.find('.category').text(data.category);
    return item;
};

const showResult = results => {
    const $resultContainer = $('.js-search-results');
    $resultContainer.html('');
    $resultContainer.css('width', $('.search-field').width());

    for (let i = 0; i < results.result.length; i += 1) {
        $resultContainer.append(generateItem(results.result[i]));
    }
};

const search = keyWord => {
    const url = $('#search-input').data('api-url');
    $.getJSON(`${url}${keyWord}`)
        .fail((jqxhr, textStatus, error) => {
            // eslint-disable-next-line no-console
            console.error(`Error: ${error}`);

            // API result format, keep this for local testing and reference
            // const demoResult = `{"result":[
            //     {
            //         "title": "some title ${Math.random()}",
            //         "category": "some category",
            //         "link": "/page-url"
            //     },
            //     {
            //         "title": "some title 2",
            //         "category": "some category",
            //         "link": "/page-url"
            //     },
            //     {
            //         "title": "some title 3",
            //         "category": "some category",
            //         "link": "/page-url"
            //     }
            // ]}`;
            // showResult(JSON.parse(demoResult));
        })
        .done(response => {
            showResult(response);
        });
};

// Init search
const initSearch = () => {
    const minLength = 1;
    const $input = $('#search-input');
    const $submit = $('.js-search-bar-submit');

    if ($input.length === 0) return;

    let timeout = null;

    $input.on('change keyup', function () {
        clearTimeout(timeout);

        timeout = setTimeout(() => {
            const val = $(this).val().trim();

            if (val.length < minLength) {
                showResult({ result: [] });
                return;
            }

            search(val);
        }, 500);
    });

    $submit.click(() => {
        const val = $input.val().trim();
        if (val.length < minLength) return;

        window.location = `${$submit.data('result-page-url')}${val}`;
    });
};

// Kick off the init on document ready
$(() => {
    initSearch();
});
